import { render, staticRenderFns } from "./reportDialog.vue?vue&type=template&id=2a45ba72&scoped=true"
import script from "./reportDialog.vue?vue&type=script&lang=js"
export * from "./reportDialog.vue?vue&type=script&lang=js"
import style0 from "./reportDialog.vue?vue&type=style&index=0&id=2a45ba72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a45ba72",
  null
  
)

export default component.exports